import { jsx, jsxs } from "react/jsx-runtime";
import * as React from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "@creditornot/cb-ingredients";
import { createCssVars, createThemedCssVarDefinitions, createCssVarDefinitions } from "@creditornot/cb-utils";
const cssVars = createCssVars(["size"]);
const colorCssVars = createCssVars(["color"]);
const sizeConfig = {
  tiny: 14,
  small: 18,
  medium: 24,
  large: 44,
  extraLarge: 64,
  huge: 96
};
const colorConfig = {
  blue: {
    light: colors.wolt100,
    dark: colors.wolt100
  },
  lightGrey: {
    light: "#A6A6A8",
    // pepper40 solid
    dark: "#7A7A7A"
    // salt48 solid
  },
  grey: {
    light: "#707173",
    // pepper64 solid
    dark: "#B8B8B8"
    // salt72 solid
  },
  white: {
    light: colors.salt100,
    dark: colors.space100
  },
  red: {
    light: colors.strawberry100,
    dark: colors.strawberry100
  }
};
const mainRotation = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;
const circle1Rotation = keyframes`
  0% {
    transform: rotate(50deg);
  }
  100% {
    transform: rotate(770deg);
  }
`;
const circle2Rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(720deg);
  }
`;
const Root = styled.div`
  ${({ $color, $cssVarOverrides }) => createThemedCssVarDefinitions({
  color: ($cssVarOverrides == null ? void 0 : $cssVarOverrides.color) ?? colorConfig[$color]
})}

  ${({ $cssVarOverrides, $size }) => createCssVarDefinitions({
  size: ($cssVarOverrides == null ? void 0 : $cssVarOverrides.size) ?? `${sizeConfig[$size]}px`
})}

  overflow: hidden;
  position: relative;
  width: ${cssVars.size};
  height: ${cssVars.size};
  display: inline-block;
`;
const AnimationContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  animation: ${mainRotation} 2.5s infinite linear;
`;
const Container1 = styled.div`
  &,
  svg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  circle {
    stroke: ${colorCssVars.color};
    stroke-opacity: 0.2;
  }
`;
const Container2 = styled.div`
  animation: ${circle1Rotation} 2.2s infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);

  &,
  svg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  circle {
    stroke: ${colorCssVars.color};
    stroke-linecap: round;
    stroke-dasharray: 50, 150;
    stroke-dashoffset: 0;
    transform-origin: center;
  }
`;
const Container3 = styled.div`
  animation: ${circle2Rotation} 2.2s infinite linear;

  &,
  svg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  circle {
    stroke: ${colorCssVars.color};
    stroke-dasharray: 45, 150;
    stroke-linecap: round;
    stroke-dashoffset: 0;
    transform-origin: center;
  }
`;
const Spinner = React.forwardRef(
  ({ color = "blue", cssVarOverrides, size, ...rest }, ref) => /* @__PURE__ */ jsx(Root, { $color: color, $cssVarOverrides: cssVarOverrides, $size: size, ...rest, ref, children: /* @__PURE__ */ jsxs(AnimationContainer, { children: [
    /* @__PURE__ */ jsx(Container1, { children: /* @__PURE__ */ jsx("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ jsx("circle", { cx: "25", cy: "25", fill: "none", r: "20", strokeWidth: "5" }) }) }),
    /* @__PURE__ */ jsx(Container2, { children: /* @__PURE__ */ jsx("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ jsx("circle", { cx: "25", cy: "25", fill: "none", r: "20", strokeWidth: "5" }) }) }),
    /* @__PURE__ */ jsx(Container3, { children: /* @__PURE__ */ jsx("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ jsx("circle", { cx: "25", cy: "25", fill: "none", r: "20", strokeWidth: "5" }) }) })
  ] }) })
);
Spinner.displayName = "Spinner";
export {
  Spinner
};
//# sourceMappingURL=index.js.map
